import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { NativeAudio } from '@ionic-native/native-audio/ngx';

@Injectable({
  providedIn: 'root',
})
export class BeepService {
  private _loaded: boolean;

  private webAudio: HTMLAudioElement;

  constructor(private _nativeAudio: NativeAudio, private platform: Platform) {}

  public start() {
    if (this.platform.is('cordova')) {
      this.notifyNative();
    } else {
      this.notifyWeb();
    }
  }

  public async stop() {
    if (this.platform.is('cordova')) {
      if (this._loaded) {
        await this._nativeAudio.stop('music');
      }
      return;
    }
    if (this.webAudio) {
      this.webAudio.pause();
      this.webAudio.currentTime = 0;
    }
  }

  private async notifyNative() {
    if (this._loaded) {
      await this._nativeAudio.loop('music');
    } else {
      try {
        const result = await this._nativeAudio.preloadComplex('music', 'audio/Beep.mp3', 1, 1, 0);
        if (result) {
          this._loaded = true;
          await this._nativeAudio.loop('music');
        }
      } catch (e) {
        console.log('beep error');
        console.log(e);
      }
    }
  }

  private notifyWeb() {
    if (!this.webAudio) {
      this.webAudio = new Audio('audio/Beep.mp3');
      this.webAudio.loop = true;
    }
    this.webAudio.play().catch(err => {
      console.log('beep play error', err);
    });
  }
}
